import React,  { useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box,  MenuItem , Typography,InputLabel,Button } from '@mui/material/';
import Select from '@mui/material/Select';

import axios from 'axios';
import { useSelector ,useDispatch} from 'react-redux'
import Cookies from 'js-cookie'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import FormLabel from '@mui/material/FormLabel';

import MembersList from '../../components/members/member_lst';

import Officers from '../../components/clubs/officers';
import Address from '../../components/clubs/address';
import InvoiceBilling from '../../components/clubs/invoice_billing';
import Autorize from '../../components/ui/autorize';
import Meetings_schedules from '../../components/clubs/meetings_schedules';



import "./club.css";
//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Club() {

    /*
    function getSessionStorageOrDefault(key, defaultValue) {
        const stored = sessionStorage.getItem(key);
        if (!stored) {
          return defaultValue;
        }
        return JSON.parse(stored);
      }

    const clubIdFromSession = getSessionStorageOrDefault("clubId",0);
    const secteurFromSession = getSessionStorageOrDefault("secteur",0);*/
      
    const [clubid, setclubid] = useState(""); 
    const [secteur, setSecteur] = useState(""); 
    const [autorize, setAutorize] = useState("false");
    const [errorAxios, setErrorAxios] = useState("false");
    const [OptionStatusClub, setOptionStatusClub] = useState([]);
   
    const [clubInfo, setClubInfo] = React.useState({   
        
        id:"",
        fk_club_type:"CLUB",
        Default_DistrictNbr:"",
        ClubName: "",       
        ClubLegalName: "",
        City: "",
        Incorporated: "",                             
            
      });


 /*
    const MyAxios = axios.create({
        headers: { 'Access-Control-Allow-Origin':  process.env.REACT_APP_API},       
        withCredentials: true,
        xsrfCookieName: 'token',
        xsrfHeaderName: 'X-XSRF-TOKEN',
    })*/
    const MyAxios = axios.create({    
        headers: { Authorization: "Bearer "+ Cookies.get('token'),
                }      
  })

    function handleChange(event) {
        const value = event.target.value;
        console.log(value);
        setClubInfo({
          ...clubInfo,
          [event.target.id]: value,
        });
      }

      
    function handleChangeIdClub(event) {  
        const value = event.target.value;          
        setClubInfo({
          ...clubInfo, "id" : value,
        });
      }

    
      function handleChangeSelectStatus(event) {
        const value = event.target.value;        
        setClubInfo({
          ...clubInfo,"Status": value,
        });
      }
   
    
  useEffect(() => {
 

    }, []);

  

         
    function SaveChange() { 
           // alert(process.env.REACT_APP_API + "/clubs/nouveauclub/");  

            MyAxios.post(process.env.REACT_APP_API + "/clubs/nouveauclub/",clubInfo)    
            .then((res) => {       
                console.log(res)
                if(res.status === 200)    
                    alert("Sauvegarde complété")
                else      
                    alert("Erreur sauvegarde") 
                
            })
            .catch((error) => {
                console.log(error)               
                alert("Erreur sauvegarde")
            });
        
    }


/*
    handleChange(event) {  
        console.log(event.target);
        this.setState({[event.target.id]: event.target.value});  
      }
*/
    
    const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
    };


    return (
            <div>
                <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>
            <form>
                   <Grid container direction="row" spacing={2}  m={2}>

                                                
                        <Grid item container direction="row" > 
                            <Box sx={{ borderRadius: 3,padding:1,margin:1}}  style={{ border: "1px solid grey" }}>
                            <Grid container spacing={1} m={2}> 

                                <Grid item xs={4} > 
                                    <TextField id="clubid" value={clubInfo.id} onChange={handleChangeIdClub} label="Numéro du club" fullWidth  />  
                                </Grid>

                                <Grid item xs={4} >     
                                    <TextField id="Default_DistrictNbr" value={clubInfo.Default_DistrictNbr} onChange={handleChange} label="Secteur du club" fullWidth  /> 
                                </Grid>

                            </Grid>
                                <Grid container spacing={1}  m={2}> 
                                  
                                    <Grid item xs={4} >      
                                        <TextField id="ClubLegalName" value={clubInfo.ClubLegalName} onChange={handleChange} label="Nom légal du club" fullWidth  />
                                    </Grid>
                                    <Grid item xs={4} >      
                                        <TextField id="City" value={clubInfo.City} onChange={handleChange} label="Ville" fullWidth  /> 
                                    </Grid>
                                

                                    <FormControl  >
                                                                    
                                   
                                       
                                       <Grid container direction="row" spacing={1}>                                                                                   
                                           <Grid item > 
                                               <Box sx={{ borderRadius: 3,padding:1,margin:1}}   style={{ border: "1px solid grey" }}>
                                                       <FormControl>
                                                       <FormLabel id="demo-row-radio-buttons-group-label">Incorporé</FormLabel>
                                                       <RadioGroup
                                                           row
                                                           aria-labelledby="demo-row-radio-buttons-group-label"
                                                           name="row-radio-buttons-group"                                        
                                                           onChange={handleChange}
                                                           value={clubInfo.Incorporated}                                        
                                                       >
                                                           <FormControlLabel  value="T" control={<Radio id="Incorporated" />} label="Oui" />
                                                           <FormControlLabel  value="F" control={<Radio id="Incorporated" />} label="Non" />   
                                                       
                                                       </RadioGroup>
                                                   </FormControl>
                                               </Box>
                                             </Grid >  
                                            

                                        </Grid>
                                   
                                        <Button onClick={SaveChange} variant="containedFifth">CLIQUEZ ICI POUR ENREGISTRER LE NOUVEAU CLUB</Button>    
                                </FormControl > 







                                </Grid>
                            </Box>


                          

     
                        </Grid>
                       
                </Grid>


       
        </form>

                  



        </div>
    );   

}

export default Club;


/*
 old facturation box.
  <Box sx={{ borderRadius: 3,padding:1,margin:1}}  style={{ border: "1px solid grey" }}>
                            
                                <Typography variant="h6" gutterBottom>Facturation</Typography>                                              
                                <InvoiceBilling key="invoicebill"  clubid={clubid} secteur={secteur}  />
                                
   </Box>

*/